type PreloadedState = {
	identifier: { email: string } | { callingCode: string; phoneNumber: string };
	type: string;
	code: string;
	password: string;
	name?: string;
	showDOBVerification?: boolean;
	dateOfBirth?: string;
	shouldShowMessage: {
		state: 'OK' | 'notOK' | 'customerSupport' | 'yesNo' | 'yesNo2' | '';
		msg?: string;
		closeButton?: string;
		supportButton?: string;
		title?: string;
		noButton?: string;
		yestButton?: string;
	};
};

const preloadedState: PreloadedState = {
	identifier: {
		email: ''
	},
	type: '',
	code: '',
	password: '',
	name: '',
	showDOBVerification: false,
	shouldShowMessage: {
		state: '',
		title: '',
		msg: '',
		supportButton: '',
		closeButton: ''
	}
};

export default preloadedState;
